export default __webpack_public_path__ + "static/media/Business-Responsibility-and-Sustainability-Reporting.1e251fc2.pdf";